// Safe-navigation helpers to prevent open-redirect and reverse-tabnabbing.

// Registrable domains (including their subdomains) permitted for cross-origin navigation.
// prod: gryphon.ai | dev: gryphon-dev.ai | int: gryphon-int.ai | legacy: gryphonnetworks.com
const ALLOWED_HOSTS = ["gryphon.ai", "gryphon-dev.ai", "gryphon-int.ai", "gryphonnetworks.com"];

const isHostAllowed = (hostname) => ALLOWED_HOSTS.some((host) => hostname === host || hostname.endsWith("." + host));

/**
 * Validate a URL for safe navigation. A URL is considered safe when it parses,
 * uses the http(s) protocol, and is either same-origin or on an allow-listed host.
 * Returns a URL object when safe, otherwise null.
 */
export const getSafeUrl = (rawUrl) => {
  try {
    const url = new URL(rawUrl, window.location.origin);
    if (url.protocol !== "http:" && url.protocol !== "https:") return null;
    if (url.origin === window.location.origin || isHostAllowed(url.hostname)) return url;
  } catch (e) {
    // Unparseable URL - treat as unsafe.
  }
  return null;
};

/**
 * Open rawUrl in a new tab only if it passes safety validation. Any queryParams are
 * appended after validation, so sensitive values (e.g. auth tokens) never leak to an
 * untrusted host when the base URL fails the allow-list check.
 */
export const openSafeUrl = (rawUrl, queryParams = {}) => {
  const url = getSafeUrl(rawUrl);
  if (!url) return;
  Object.entries(queryParams).forEach(([key, value]) => url.searchParams.set(key, value));
  window.open(url.href, "_blank", "noopener,noreferrer");
};
